// components/LampiranB.jsx
import React from 'react';
import { TIME } from '../../../services/util';


// Styles 
// import styles from './index.module.css'

import { DRIVER_PRETRIP_CHECKLIST_CATEGORY_LABEL_MALAY } from '../../../constants/template/driver';

const PretripInspectionReport = ({ data = {} }) => {
    const d = data;

    function groupByCategory(items, labels) {
        const grouped = items.reduce((acc, item) => {
            if (!acc[item.category]) acc[item.category] = [];
            acc[item.category].push(item);
            return acc;
        }, {});

        return Object.keys(grouped).map((code) => ({
            code,
            label: labels[code] || code,
            items: grouped[code],
        }));
    }

    const groupedPretrip = groupByCategory(d.pretripDetails ?? [], DRIVER_PRETRIP_CHECKLIST_CATEGORY_LABEL_MALAY);

    return (
        <>
        <style>{css}</style>
        <div id="document-page">

            {/* ── HEADER ── */}
            <div className="lb-header">
            <h1 className="lb-title">LAMPIRAN B</h1>
            <p className="lb-subtitle">
                (Senarai Semakan Harian Kenderaan oleh SHO atau SHS dan pemandu
                <br />(sebelum dan selepas perjalanan))
            </p>
            <h2 className="lb-section-title">SENARAI SEMAKAN HARIAN KENDERAAN</h2>
            <p className="lb-plat">No. Plat : {d.plate}</p>
            </div>

            {/* ── TABLE SECTION A — METER ── */}
            <table className="lb-table">
            <thead>
                <tr>
                <th className="lb-th-empty" colSpan={2}></th>
                <th className="lb-th-col">Sebelum<br />Perjalanan</th>
                <th className="lb-th-col">Selepas<br />Perjalanan</th>
                </tr>
            </thead>
            <tbody>
                {/* Section header row */}
                <tr className="lb-section-row">
                <td className="lb-section-letter">A</td>
                <td className="lb-section-label">METER</td>
                <td className="lb-section-sub">KM</td>
                <td className="lb-section-sub">KM</td>
                </tr>
                <tr>
                <td className="lb-arrow">➤</td>
                <td className="lb-item-label">Pembacaan Meter (Sebelum dan selepas perjalanan)</td>
                <td className="lb-cell-center">{d.odometerStart}</td>
                <td className="lb-cell-center">{d.odometerEnd}</td>
                </tr>
                <tr>
                <td className="lb-arrow">➤</td>
                <td className="lb-item-label">Masa (Sebelum dan selepas perjalanan)</td>
                <td className="lb-cell-center" style={{ whiteSpace: 'pre-line' }}>{TIME.parseTime(d.createdAt)}</td>
                <td className="lb-cell-center">{TIME.parseTime(d.createdAt)}</td>
                </tr>
            </tbody>
            </table>

            {/* ── TABLE SECTION B — PENYELENGGARAAN ── */}
            <table className="lb-table" style={{ marginTop: 16 }}>
            <thead>
                <tr>
                <th className="lb-th-empty" colSpan={2}></th>
                <th className="lb-th-col">YA (✓)</th>
                <th className="lb-th-col">TIDAK (X)</th>
                </tr>
            </thead>
            
            <tbody>
            {groupedPretrip.map((group, i) => (
                <React.Fragment key={group.code}>
                <tr className="lb-section-row">
                    <td className="lb-section-letter">{String.fromCharCode(65 + i)}</td>
                    <td className="lb-section-label" colSpan={3}>{group.label}</td>
                </tr>
                {group.items.map((item, i) => (
                    <tr key={`${item.itemid}#${i}`}>
                    <td className="lb-arrow">➤</td>
                    <td className="lb-item-label">
                        {item.itemMalay}
                        <span style={{ color: '#9ca3af', fontSize: 10, marginLeft: 6 }}>
                        ({item.item})
                        </span>
                    </td>
                    <td className="lb-cell-center">
                        {item.isChecked === true && <span className="lb-check">✓</span>}
                    </td>
                    <td className="lb-cell-center">
                        {item.isChecked === false && <span className="lb-cross">✗</span>}
                    </td>
                    </tr>
                ))}
                </React.Fragment>
            ))}
            </tbody>

            </table>

            {/* ── CATATAN / NOTES ── */}
            <div className="lb-notes">
            <div className="lb-notes-head">CATATAN / NOTES</div>
            <div className="lb-notes-body">{d.note}</div>
            </div>

            {/* ── SIGNATURES ── */}
            <div className="lb-signatures">
            <div className="lb-sig-block">
                <div className="lb-sig-role">DRIVER / PEMANDU</div>
                <div className="lb-sig-line"></div>
                <div className="lb-sig-name">{d.name}</div>
                <div className="lb-sig-date">Submitted: {TIME.parseTime(d.createdAt)}</div>
            </div>
            <div className="lb-sig-block">
                <div className="lb-sig-role">CHECKED BY</div>
                <div className="lb-sig-line"></div>
                <div className="lb-sig-name">{d.checkedBy}</div>
                <div className="lb-sig-date">Checked: {d.checkedAt}</div>
            </div>
            <div className="lb-sig-block">
                <div className="lb-sig-role">VERIFIED BY</div>
                <div className="lb-sig-line"></div>
                <div className="lb-sig-name">{d.verifiedBy}</div>
                <div className="lb-sig-date">Verified: {d.verifiedBy}</div>
            </div>
            </div>

            {/* ── FOOTER NOTE ── */}
            <div className="lb-footer-note">
            This downloadable PDF is generated from the selected Pre-Trip submission.
            The calendar/report screen is used for monitoring, while this Lampiran B format
            is used for official printable record and attachment.
            </div>

        </div>
        </>
    );
}

export default PretripInspectionReport

const css = `
  #document-page {
    width: 210mm;
    min-height: 297mm;
    margin: 24px auto;
    background: #fff;
    padding: 12mm 14mm 10mm;
    box-shadow: 0 4px 20px rgba(0,0,0,0.13);
    box-sizing: border-box;
    font-family: Arial, Helvetica, sans-serif;
    color: #222;
    font-size: 12px;
  }
  #document-page * { box-sizing: border-box; }

  /* HEADER */
  .lb-header {
    text-align: center;
    margin-bottom: 14px;
  }
  .lb-title {
    font-size: 26px;
    font-weight: 700;
    margin: 0 0 6px 0;
    letter-spacing: 1px;
  }
  .lb-subtitle {
    font-size: 12px;
    margin: 0 0 12px 0;
    line-height: 1.6;
    color: #333;
  }
  .lb-section-title {
    font-size: 15px;
    font-weight: 700;
    margin: 0 0 8px 0;
    letter-spacing: 0.5px;
  }
  .lb-plat {
    font-size: 14px;
    font-weight: 600;
    margin: 0;
  }

  /* TABLE */
  .lb-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
  }

  /* header row (Sebelum/Selepas) */
  .lb-th-empty {
    border: 1px solid #ccc;
    background: #f5f5f5;
    padding: 8px;
    width: 70%;
  }
  .lb-th-col {
    border: 1px solid #ccc;
    background: #f5f5f5;
    text-align: center;
    padding: 8px 6px;
    font-size: 11.5px;
    font-weight: 700;
    width: 15%;
    line-height: 1.4;
  }

  /* section header row (A / B) */
  .lb-section-row {
    background: #e8e8e8;
  }
  .lb-section-letter {
    border: 1px solid #ccc;
    text-align: center;
    font-weight: 700;
    padding: 7px 6px;
    width: 36px;
    font-size: 12px;
  }
  .lb-section-label {
    border: 1px solid #ccc;
    font-weight: 700;
    padding: 7px 10px;
    font-size: 12px;
  }
  .lb-section-sub {
    border: 1px solid #ccc;
    text-align: center;
    font-weight: 700;
    padding: 7px 6px;
    font-size: 12px;
  }

  /* data rows */
  .lb-arrow {
    border: 1px solid #ccc;
    text-align: center;
    padding: 7px 4px;
    color: #555;
    font-size: 11px;
    width: 36px;
  }
  .lb-item-label {
    border: 1px solid #ccc;
    padding: 7px 10px;
    color: #333;
  }
  .lb-cell-center {
    border: 1px solid #ccc;
    text-align: center;
    padding: 7px 6px;
    vertical-align: middle;
  }

  /* check / cross marks */
  .lb-check {
    color: #16a34a;
    font-size: 16px;
    font-weight: 700;
    line-height: 1;
  }
  .lb-cross {
    color: #dc2626;
    font-size: 16px;
    font-weight: 700;
    line-height: 1;
  }

  /* NOTES */
  .lb-notes {
    margin-top: 16px;
    border: 1px solid #ccc;
    border-radius: 4px;
    overflow: hidden;
  }
  .lb-notes-head {
    background: #e8e8e8;
    font-size: 11.5px;
    font-weight: 700;
    padding: 7px 12px;
    border-bottom: 1px solid #ccc;
    letter-spacing: 0.3px;
  }
  .lb-notes-body {
    padding: 12px;
    font-size: 12px;
    color: #333;
    line-height: 1.55;
    min-height: 48px;
  }

  /* SIGNATURES */
  .lb-signatures {
    margin-top: 20px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 0;
    border: 1px solid #ccc;
  }
  .lb-sig-block {
    padding: 14px 14px 12px;
    border-right: 1px solid #ccc;
  }
  .lb-sig-block:last-child {
    border-right: none;
  }
  .lb-sig-role {
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 28px;
    color: #444;
  }
  .lb-sig-line {
    border-top: 1.5px solid #555;
    margin-bottom: 6px;
  }
  .lb-sig-name {
    font-size: 13px;
    font-weight: 700;
    margin-bottom: 3px;
  }
  .lb-sig-date {
    font-size: 10px;
    color: #e05c00;
    font-weight: 600;
  }

  /* FOOTER NOTE */
  .lb-footer-note {
    margin-top: 14px;
    font-size: 9.5px;
    color: #555;
    line-height: 1.55;
    font-style: italic;
  }

  @media print {
    #document-page { box-shadow: none; margin: 0; }
  }
`;